import React from "react";
import DwNav from "../components/DwNav";

const Shots = (props) => {
  return (
    <div className="app-container">
      <DwNav />
      <header>
        <h1>Shots Page</h1>
      </header>
    </div>
  )
}

export default Shots